import { useMemo } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { buildAriRosterClients } from "@/mockData/ariPortfolio";
import { PATH_ROOT } from "@/routes/paths";

import { ClientHub } from "./AriDemoRosterPage";

export default function AriDemoClientHubPage() {
  const navigate = useNavigate();
  const { clientId } = useParams<{ clientId: string }>();
  const client = useMemo(
    () => buildAriRosterClients().find((item) => item.id === clientId),
    [clientId],
  );

  if (!client) {
    return <Navigate to={PATH_ROOT.demo.roster} replace />;
  }

  return (
    <ClientHub
      client={client}
      onBack={() => navigate(PATH_ROOT.demo.roster)}
    />
  );
}
